import angular from 'angular';
import fileHeader from './fileHeader';
import applicationWidgets from './applicationWidgets';

export default angular.module('viewOfFile.scenes', [
  fileHeader,
  applicationWidgets,
]).name;
